var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"treatment-container"}},[_c('treatment',{attrs:{"isDashboard":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }